import { render, staticRenderFns } from "./FormulaMasuraAptamil.vue?vue&type=template&id=a4e80d32&"
import script from "./FormulaMasuraAptamil.vue?vue&type=script&lang=js&"
export * from "./FormulaMasuraAptamil.vue?vue&type=script&lang=js&"
import style0 from "./FormulaMasuraAptamil.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports